<template>
  <div class="copyright-footer">
    <router-link :to="{ name: 'service' }">Sharewind</router-link>
    <span>Copyright © 2021 IWATSU ELECTRIC CO., LTD. All Rights Reserved.</span>
  </div>
</template>

<script>
export default {
  name: 'CopyrightFooter'
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.copyright-footer {
  height: 40px;
  margin-top: -40px;
  padding-right: 20px;
  font-size: 11px;
  display: none;
  color: $light-text-color;

  @include mq(md) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  a {
    color: $light-text-color;
    margin-right: 20px;
  }
}
</style>
